import { Field, FieldEntry, FieldJumpRuleTargetType } from 'scripts/type'
import calcIsConditionGroupMatched from './calcIsConditionGroupMatched'

export default function calcIsLastPage(values: FieldEntry[], currentDisplayFields: Field[]) {
  if (values.length === 0) {
    return undefined
  }
  let matchedFirstJumpRuleTargetType: FieldJumpRuleTargetType | undefined = undefined
  for (const { code, jumpRule } of currentDisplayFields) {
    for (const { conditionGroup, targetType } of jumpRule?.subRules ?? []) {
      if (
        conditionGroup &&
        calcIsConditionGroupMatched(conditionGroup, values.find((fieldEntry) => fieldEntry.code === code)?.value)
      ) {
        matchedFirstJumpRuleTargetType = targetType
        break
      }
    }
    if (matchedFirstJumpRuleTargetType) {
      break
    }
    if (jumpRule?.targetType && jumpRule.targetType !== FieldJumpRuleTargetType.NextField) {
      matchedFirstJumpRuleTargetType = jumpRule.targetType
      break
    }
  }
  return matchedFirstJumpRuleTargetType === undefined
    ? undefined
    : matchedFirstJumpRuleTargetType === FieldJumpRuleTargetType.Ending
}
